export const SOBREPOSICOES_REQUEST = "SOBREPOSICOES_REQUEST";
export const SOBREPOSICOES_SUCCESS = "SOBREPOSICOES_SUCCESS";
export const SOBREPOSICOES_FAIL = "SOBREPOSICOES_FAIL";
